module.exports = __webpack_public_path__ + "static/fonts/ProximaNovaT-Thin.56960a12.ttf";